import * as React from 'react';
import Typography from '@mui/material/Typography';
import { AccordionSummary, AccordionDetails, SvgIcon } from '@mui/material';
import { ReactComponent as ExpandMore } from 'assets/icons/arrow-down.svg';
import { StyledControlledAccordion } from './MenuLinksStyles';

export default function ControlledAccordions({ data }) {
  return (
    <StyledControlledAccordion expanded={data.expanded} onChange={data.onChange} disableGutters={true}>
      <AccordionSummary
        expandIcon={<SvgIcon component={ExpandMore} inheritViewBox />}
        aria-controls={data.label}
        id={data.id}
      >
        <Typography variant="DS_labelSmallBold">{data.label}</Typography>
      </AccordionSummary>
      <AccordionDetails>{data.value}</AccordionDetails>
    </StyledControlledAccordion>
  );
}
